import React, { useCallback, useEffect, useState, useRef } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper";
import Card from "../../../components/common/Card";
import CardHeader from "../../../components/common/CardHeader";
import CardBody from "../../../components/common/CardBody";
import CardTitle from "../../../components/common/CardTitle";
import AdminTemplate from "../../../components/admin/layouts/Template";
import HirearchyCard from "./HirearchyCard";
import TabSection from "./TabSection.js";
import Grid from "@mui/material/Grid";
import { Tabs, Tab } from "@mui/material";
import CustomEditor from "../../../pages/manage/enrollment/CustomEditor.js";
import AddCard from "./AddCard";
import "./hirearchy.css";
import { TreeMainService } from "../../../service/manage/h_tree/tree_main.service";
import { history } from "../../../helper/history";
import { Row, Col, Spinner, Button, Form, Modal } from "react-bootstrap";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import {
  sweetSuccessAlert,
  sweetStatusAlert,
  sweetConfirmAlert,
} from "../../../components/common/SweetAlert";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import { ChatService } from "../../../service/manage/chat/chat.service";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import ErrorIcon from "@mui/icons-material/Error";
import { convertToRaw, EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { ProgressService } from "../../../service/manage/progress_catchup/progress.service.js";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import SimpleReactValidator from "simple-react-validator";
import { NodeGroupService } from "../../../service/settings/manage/node_group_title.service.js";
import Divider from "@mui/material/Divider";
import "./Search.css";
import Slider from "@mui/material/Slider";
import { emphasize, styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import { formFixture } from "./FormFixture";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";
import queryString from "query-string";
import { CombankService } from "../../../service/manage/subscription/combank_pg.service.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useMainContext } from "../../../context/hooks/use-main-context.js";
import layerIcon from "../../../assets/images/addlayer.png";
import Chip from "@mui/material/Chip";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();

switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

function EdfociNodeBuilder() {
  const {
    get_all_node_array,
    node_array,
    nodes_data,

    set_node_array,
    set_form_array,

    get_all_forms,
    form_array,

    set_loading_node_state,
    loadingNode,

    set_form_loading_state,
    formLoading,

    set_highlighted_card,
    highlightCard,

    set_selected_form,
    selected_form,

    get_selcted_node_level_node_array,
    selected_node_level_node_array,

    insert_hierarchy_node,
    hierarchy_node_add_state,
    set_hierarchy_node_add_state,

    last_mid,
    last_fmid,
    last_formid,

    set_last_mid,
    set_last_fmid,
    set_last_formid,

    set_auth_code_graph_api,
    authorize_code_graph_api,
  } = useMainContext();

  const [validator, setValidator] = useState(new SimpleReactValidator());

  const [status, setStatus] = useState();
  const [isCardSectionVisible, setIsCardSectionVisible] = useState(false);

  const [root_node_id, setRootNodeId] = useState(null);
  const [selected_card_id, setSelectedCardId] = useState(null);
  const [selected_form_id, setSelectedFormId] = useState(null);

  const [selectedMid, setSelectedMid] = useState(null);

  const [data_id, setDataId] = useState(null);
  const [pid, setPid] = useState(null);
  const [hierarchyGridBottomData, setHierarchyGridBottomData] = useState([]);
  const [hierarchyGridTopData, setHierarchyGridTopData] = useState([]);
  const [selectedMidsForms, setSelectedMidsForms] = useState([]);
  const [selectedFormDetail, setSelectedFormDetail] = useState(null);

  const [mcode, setMcode] = useState("");
  const [title, setTitle] = useState("");
  const [groupTitle, setGroupTitle] = useState("");

  const [displayOrder, setDisplayOrder] = useState(1);
  const [flg_node_hide, set_flg_node_hide] = useState(0);

  const [breadcrumbsDataArray, setBreadcrumbsDataArray] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chat_backDrop, setChatBackDrop] = useState(false);
  const [isMobile, setiIsMobile] = useState(window.innerWidth <= 900);

  const [user_id, setUserId] = useState(
    sessionStorage.getItem("manage_user_id")
  );
  const [user_table_id, setUserTableId] = useState(
    sessionStorage.getItem("table_log_id")
  );
  const [mid, setMid] = useState(
    !!(history.location.state && history.location.state.pid)
      ? history.location.state.pid
      : status
      ? 10
      : root_node_id
  );
  const [fmid, setFmid] = useState(null);
  const [smid, setSmid] = useState(null);
  const [formId, setFormId] = useState(null);
  const [titles, setTitles] = useState([]);
  const [user, setUser] = useState(sessionStorage.getItem("userType"));
  const [insertType, setInsertType] = useState("null");

  const [showInsertModal, setShowInsertModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [hierarchyCardInsertion, setHierarchyCardInsertion] = useState(false);
  const [isHideForExam, setIsHideForExam] = useState(true);
  const [forceUpdate, setForceUpdate] = useState(false);

  const selectedCardRef = useRef(null);
  const selectedTabRef = useRef(null);

  const [distinctLevels, setDistinctLevels] = useState([]);

  const getSelectedNodeLevelHierarchy = useCallback(async (mid) => {
    try {
      await get_selcted_node_level_node_array(mid, 1, user_id, user_table_id);
    } catch (error) {
      console.error(error);
    }
  }, []);

  function getAllNodeGroupTitls() {
    NodeGroupService.getNodeGroups().then((response) => {
      if (response.success) {
        setTitles(response.data);
      }
    });
  }

  const getHierarchy = useCallback(async (mid, user_id, user_table_id) => {
    try {
      set_loading_node_state(true);
      set_form_loading_state(true);
      setIsHideForExam(true);

      await get_all_node_array(mid, 1, user_id, user_table_id);

      set_loading_node_state(false);
    } catch (error) {
      console.error(error);
      set_loading_node_state(false);
      set_form_loading_state(false);
    }
  }, []);

  const insertHierarchyNode = useCallback(async (child) => {
    try {
      await insert_hierarchy_node(child);
    } catch (error) {
      console.error(error);
      sweetStatusAlert("Failed!", "Unable to insert the node", "error");
    }
  }, []);

  const handleResize = () => {
    setiIsMobile(window.innerWidth <= 900);
  };

  const setHideForExam = (bool) => {
    setIsHideForExam(bool);
  };

  function handlePaymentResponse() {
    const query = new URLSearchParams(window.location.search);
    const success = query.get("success");
    const cancel = query.get("cancel");
    const userType = sessionStorage.getItem("userType");
    if (success === "true") {
      if (customerConstants.EXO_CUSTOMER2 === getCustomerFeatureFlag()) {
        query.delete("success");
        sweetStatusAlert("Success!", "Your payment was successful!", "success");
        this.redirectToSubscriptions(query);
      } else {
        CombankService.retrieveOrder(
          sessionStorage.getItem("checkout_session_id")
        ).then((response) => {
          sessionStorage.removeItem("checkout_session_id");
          query.delete("success");
          sweetStatusAlert(
            "Success!",
            "Your payment was successful!",
            "success"
          );
          if (userType !== "admin") {
            this.redirectToSubscriptions(query);
          } else {
            const newQueryString = query.toString();
            const newUrl = newQueryString
              ? window.location.pathname + "?" + newQueryString
              : window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
            return true;
          }
        });
      }
    } else if (cancel === "true") {
      query.delete("cancel");
      sweetStatusAlert("Failed!", "Your payment is failed!", "error");
      if (userType !== "admin") {
        this.redirectToSubscriptions(query);
      } else {
        const newQueryString = query.toString();
        const newUrl = newQueryString
          ? window.location.pathname + "?" + newQueryString
          : window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
        return true;
      }
    }
    return false;
  }

  const createValidationsInstance = () => {
    const newValidator = new SimpleReactValidator();
    return newValidator;
  };

  function handleClick(item) {
    if (item && item.pid) {
      setBreadcrumbsDataArray((prevData) => {
        const clickedIndex = prevData.findIndex(
          (previtem) => previtem.mid === item.mid
        );
        const updatedData = prevData.slice(0, clickedIndex);
        return updatedData;
      });

      setRootNodeId(item.pid);
      setSelectedCardId(null);
      setSelectedFormId(null);
    }
  }

  const selectNode = useCallback(async (selectedMid) => {
    try {
      set_form_loading_state(true);
      setSelectedMidsForms([]);
      set_form_array([]);

      await get_all_forms(selectedMid, -1, user_id, user_table_id);
    } catch (error) {
      console.error("Error fetching forms:", error);
      set_form_loading_state(false);
    }
  }, []);

  const buildBreadcrumbs = (data) => {
    
    const breadcrumbElements = data?.map((item, index) => {
      return (
        <StyledBreadcrumb
          key={item.mid || index}
          component="a"
          label={item?.title}
          disabled={loadingNode}
          onClick={() => handleClick(item)}
        />
      );
    });

    const addPriviladge = data[data.length-1].flg_add_node_sibling

    if(addPriviladge){

      breadcrumbElements.push(
        <div
          key="icon"
          style={{ cursor: "pointer", width: "34px", height: "34px" }}
          onClick={() => toggleModal(true)}
        >
          <img style={{ width: "34px", height: "34px" }} src={layerIcon} />
        </div>
      );
    }

    setBreadcrumbs(breadcrumbElements);
  };

  useEffect(() => {
    setHierarchyGridBottomData([]);
    setBreadcrumbsDataArray([]);
    set_node_array([]);

    set_loading_node_state(true);
    set_form_loading_state(true);

    setBreadcrumbs([]);
    setSelectedMidsForms([]);
    setSelectedFormDetail(null);
    setSelectedMid(null);
    setValidator(createValidationsInstance());
    setStatus(handlePaymentResponse());

    let temp_user_id = sessionStorage.getItem("manage_user_id");
    setUserId(temp_user_id);

    let temp_user_table_id = sessionStorage.getItem("table_log_id");
    setUserTableId(temp_user_table_id);

    let userType = sessionStorage.getItem("userType");
    setUser(userType);

    let temp_root_node_id = last_mid
      ? last_mid
      : parseInt(queryString.parse(history.location.search).fmid)
      ? parseInt(queryString.parse(history.location.search).fmid)
      : sessionStorage.getItem("root_node_id")
      ? sessionStorage.getItem("root_node_id")
      : user === "admin"
      ? 10
      : 100;

    setRootNodeId(parseInt(temp_root_node_id));

    let tempSelectedCardId = last_fmid
      ? last_fmid
      : parseInt(queryString.parse(history.location.search).smid)
      ? parseInt(queryString.parse(history.location.search).smid)
      : null;

    setSelectedCardId(tempSelectedCardId);

    let tempSelectedFormId = last_formid
      ? last_formid
      : parseInt(queryString.parse(history.location.search).formid)
      ? parseInt(queryString.parse(history.location.search).formid)
      : null;

    let authorizeCodeGraphAPI = queryString.parse(history.location.search).code
      ?queryString.parse(history.location.search).code
      : null;
      
    set_auth_code_graph_api(authorizeCodeGraphAPI)
    setSelectedFormId(tempSelectedFormId);

    getAllNodeGroupTitls();

    window.addEventListener("resize", handleResize);

    handlePaymentResponse();
  }, []);

  useEffect(() => {
    if (root_node_id && !selected_card_id && !selected_form_id) {
      set_last_mid(parseInt(root_node_id));
      history.replace(`/manage-search?fmid=${root_node_id}`);
    } else if (root_node_id && selected_card_id && !selected_form_id) {
      set_last_mid(parseInt(root_node_id));
      set_last_fmid(parseInt(selected_card_id));
      history.replace(
        `/manage-search?fmid=${root_node_id}&smid=${selected_card_id}`
      );
    } else if (root_node_id && selected_card_id && selected_form_id) {
      set_last_mid(parseInt(root_node_id));
      set_last_fmid(parseInt(selected_card_id));
      set_last_formid(parseInt(selected_form_id));
      history.replace(
        `/manage-search?fmid=${root_node_id}&smid=${selected_card_id}&formid=${selected_form_id}`
      );
    }

    if(authorize_code_graph_api){
      
      set_auth_code_graph_api(authorize_code_graph_api)
      history.replace(
        `/manage-search?fmid=${root_node_id}&smid=${selected_card_id}&formid=${selected_form_id}&code=${authorize_code_graph_api}`
      );
    }
  }, [root_node_id, selected_card_id, selected_form_id,authorize_code_graph_api]);

  useEffect(() => {
    if (user_id && user_table_id && root_node_id) {
      getHierarchy(root_node_id, user_id, user_table_id);
    }
  }, [user_id, user_table_id, root_node_id]);

  useEffect(() => {
    
    if (node_array && node_array.success && node_array.data.length > 0) {
      const nodes = node_array?.data || [];

      // Get distinct levels and identify second last level
      const levels = [...new Set(nodes.map((node) => node.level_id))].sort(
        (a, b) => a - b
      );

      setDistinctLevels(levels);

      let slectedLevel = null;

      if (selected_card_id) {
        slectedLevel = nodes.find(
          (node) => node.mid === parseInt(selected_card_id)
        );
      }

      const lastLevel = Math.max(...levels);

      const secondLastLevel = slectedLevel
        ? slectedLevel.level_id
        : levels.length > 1
        ? levels[levels.length - 2]
        : lastLevel;

      let hierarchyGridBottomData = [];
      let hierarchyGridTopData = [];

      if (levels.length === 1) {
        // Special case for single level
        hierarchyGridBottomData = nodes;
        hierarchyGridTopData = [nodes[0]];
      } else if (levels.length === 2) {
        hierarchyGridTopData = [
          nodes.find((node) => node.level_id <= secondLastLevel),
        ];

        hierarchyGridBottomData = nodes
          .filter((node) => node.level_id === secondLastLevel)
          .map((bottomNode) => {
            const formArray = nodes.filter(
              (node) => node.pid === bottomNode.mid
            );
            return { ...bottomNode, formArray };
          });
      } else {
        // Normal case for multiple levels
        hierarchyGridTopData = nodes.filter(
          (node) => node.level_id < secondLastLevel
        );

        hierarchyGridBottomData = nodes
          .filter((node) => node.level_id === secondLastLevel)
          .map((bottomNode) => {
            const formArray = nodes.filter(
              (node) => node.pid === bottomNode.mid
            );
            return { ...bottomNode, formArray };
          });
      }

      if (selected_card_id) {
        let selectCard = nodes.find(
          (node) => node.mid === selected_card_id || node.mid === last_fmid
        );

        if (selectCard) {
          set_highlighted_card(selectCard);
        } else {
          setSelectedCardId(hierarchyGridBottomData[0].mid);
          set_highlighted_card(hierarchyGridBottomData[0]);
        }
      } else if (last_fmid) {
        let selectCard = nodes.find((node) => node.mid === last_fmid);

        if (selectCard) {
          set_highlighted_card(selectCard);
        } else {
          setSelectedCardId(hierarchyGridBottomData[0].mid);
          set_highlighted_card(hierarchyGridBottomData[0]);
        }
      } else {
        setSelectedCardId(hierarchyGridBottomData[0].mid);
        set_highlighted_card(hierarchyGridBottomData[0]);
      }

      // Set data based on response scenarios
      switch (levels.length) {
        case 1:
          setHierarchyGridBottomData(hierarchyGridBottomData);
          setBreadcrumbsDataArray(hierarchyGridTopData);
          break;

        case 2:
          setHierarchyGridBottomData(hierarchyGridBottomData);
          setBreadcrumbsDataArray(hierarchyGridTopData);
          break;

        default:
          setHierarchyGridBottomData(hierarchyGridBottomData);
          setBreadcrumbsDataArray(hierarchyGridTopData);
          break;
      }

      set_loading_node_state(false);
    } else if (node_array && !node_array.success) {
      set_loading_node_state(false);
    }
  }, [node_array]);

  useEffect(() => {
    if (breadcrumbsDataArray && breadcrumbsDataArray.length > 0) {
      buildBreadcrumbs(breadcrumbsDataArray);
    }
  }, [breadcrumbsDataArray, loadingNode]);

  useEffect(() => {
    if (hierarchyGridBottomData && hierarchyGridBottomData.length > 0) {
      selectNode(
        hierarchyGridBottomData[hierarchyGridBottomData.length - 1].pid
      );
    }
  }, [hierarchyGridBottomData]);

  useEffect(() => {
    if (
      highlightCard &&
      form_array &&
      form_array.success &&
      form_array.data.length > 0
    ) {
      let modifiedMidForms = form_array?.data?.filter((row) => {
        let isMatch = row.node_mid === highlightCard.mid;
        if (isMatch) {
          return row;
        }
      });

      if (modifiedMidForms && modifiedMidForms.length > 0) {
        setSelectedMidsForms(modifiedMidForms);

        if (selected_form_id) {
          let selectForm = modifiedMidForms.find(
            (form) => form.form_list_id === selected_form_id
          );

          if (selectForm) {
            set_selected_form(selectForm);
          } else {
            setSelectedFormId(modifiedMidForms[0].form_list_id);
            set_selected_form(modifiedMidForms[0]);
          }
        } else {
          setSelectedFormId(modifiedMidForms[0].form_list_id);
          set_selected_form(modifiedMidForms[0]);
        }
      } else {
        setSelectedMidsForms([]);
        set_selected_form(null);
        setSelectedFormId(null);
      }
    } else {
      console.error("FAILED TO LOAD FORMS !!!!");
      set_form_loading_state(false);
    }
  }, [highlightCard, form_array]);

  useEffect(() => {
    if (selected_form && selectedMidsForms && selectedMidsForms.length > 0) {
      const selectedFormObject = selectedMidsForms.find(
        (item) => item.form_list_id === parseInt(selected_form.form_list_id)
      );

      if (selectedFormObject) {
        setSelectedFormDetail(selectedFormObject);
      } else {
        setSelectedFormId(selectedMidsForms[0].form_list_id);
        setSelectedFormDetail(selectedMidsForms[0]);
      }

      set_form_loading_state(false);
    }
  }, [selected_form, selectedMidsForms]);

  useEffect(() => {
    if (hierarchy_node_add_state && hierarchy_node_add_state.success) {
      setIsLoading(false);
      setShowInsertModal(false);
      sweetStatusAlert("Success!", "Node added successfully", "success");

      getHierarchy(highlightCard.pid, user_id, user_table_id);

      setMcode("");
      setGroupTitle("");
      set_flg_node_hide(0);
      setPid(null);
      setDisplayOrder(1);
      setDataId(null);
      setInsertType("null");
      setHierarchyCardInsertion(false);
      set_hierarchy_node_add_state(null);
    } else if (hierarchy_node_add_state && !hierarchy_node_add_state.success) {
      setIsLoading(false);
      set_hierarchy_node_add_state(null);
      sweetStatusAlert("Failed!", "Unable to insert the node", "error");
    }
  }, [hierarchy_node_add_state]);

  useEffect(() => {
    if (selectedCardRef.current) {
      selectedCardRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [highlightCard?.mid]);

  useEffect(() => {
    if (selectedTabRef.current) {
      selectedTabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selected_form]);

  const redirect = useCallback(
    async (cardData = undefined, child = undefined) => {
      if (cardData) {
        setSelectedCardId(cardData.mid);
        set_highlighted_card(cardData);
        setSelectedFormId(null);
      } else if (child) {
        setRootNodeId(child.pid);
        setSelectedCardId(child.mid);
        setSelectedFormId(null);
      }
    },
    []
  );

  const handleApplicationSelect = (formData) => {
    if (!formData) {
      return undefined;
    }
    let state = {
      pid: selected_form.pid,
      mid: formData.node_mid,
      lg_user_id: formData.lg_user_id,
      lg_user_table_id: formData.lg_user_table_id,
      flg_list_active: formData.flg_list_active,
      privilege_view: formData.privilege_view,
      privilege_edit: formData.privilege_edit,
      privilege_add: formData.privilege_add,
      privilege_delete: formData.privilege_delete,
      owner_restriction: formData.owner_restriction,
      user_list_restriction: formData.user_list_restriction,
      form_display_title: formData.form_display_title,
      form_display_order: formData.form_display_order,
      form_list_id: formData.form_list_id,
      breadcrumb1: formData.breadcrumb1,
      breadcrumb2: formData.breadcrumb,
      main_table_id: formData.main_table_id,
      nodeTitle: selected_form.title,
      node_mid_actual: formData.node_mid_actual,
      path: "node",
      mcode: selected_form.mcode,
    };
    const findComponent = (id, state) => {
      return formFixture(state).find((item) => id === item.formListId);
    };
    const selectedComponent = findComponent(formData.form_list_id, state);
    const nodeProps = {
      getDashboardStats: () =>
        getHierarchy(highlightCard.mid, user_id, user_table_id),
      selectNode: () =>
        selectNode(
          highlightCard.pid,
          -1,
          user_id,
          user_table_id,
          hierarchyGridBottomData,
          formData.form_list_id
        ),
      setIsHideForExam: (bool) => setHideForExam(bool),
    };
    if (selectedComponent && selectedComponent.component) {
      const uniqueKey = formData.node_mid;
      return React.cloneElement(
        selectedComponent.component(nodeProps),
        { key: uniqueKey }
      );
    }
    return undefined;
  };

  // ----- MODIFIED toggleModal function -----
  const toggleModal = (
    isIntermediate = false,
    passedPid = root_node_id,
    hierarchyCardInsertion = false
  ) => {
    // Clear validation messages
    validator.hideMessageFor("groupTitle");
    validator.hideMessageFor("mcode");
    validator.hideMessageFor("title");
    validator.hideMessages();
    validator.purgeFields();

    let newPid = passedPid;
    if (isIntermediate) {
      // If creating a sibling node, try to get the parent from the top-level hierarchy data
      if (hierarchyGridTopData && hierarchyGridTopData.length > 0) {
        newPid = hierarchyGridTopData[hierarchyGridTopData.length - 1].mid;
      }
      setInsertType("L");
      setHierarchyCardInsertion(hierarchyCardInsertion);
    } else {
      setInsertType("null");
    }
    setShowInsertModal(true);
    setMcode("");
    setGroupTitle("");
    setTitle("");
    setPid(newPid);
  };

  const closeModal = () => {
    setShowInsertModal(false);
    setMcode("");
    setGroupTitle("");
    setTitle("");
    setPid(root_node_id);
    validator.hideMessages();
  };
  

  const toggleCardSection = () => {
    setIsCardSectionVisible((prevState) => !prevState);
  };

  const toggleUpdateModal = (row) => {
    setShowUpdateModal((prevShowUpdateModal) => {
      if (!prevShowUpdateModal && row) {
        setMid(row.mid || "");
        setMcode(row.mcode || "");
        setGroupTitle(row.title || "");
        set_flg_node_hide(row.flg_node_hide || 0);
        setDisplayOrder(row.display_order || 1);
        setGroupTitle(row.group_title || "");
        setTitle(row.title);
        return true;
      }

      // Reset state and close modal
      setMid(null);
      setMcode("");
      setGroupTitle("");
      set_flg_node_hide(0);
      setPid(null);
      setDisplayOrder(1);
      setDataId(null);
      setInsertType("null");
      setTitle("");
      return false;
    });
  };

  const setFormDetail = (formDetail) => {
    if (!formDetail) {
      return;
    }
    setSelectedFormId(formDetail.form_list_id);
    const matchingForms = selectedMidsForms.filter(
      (item) => item.form_list_id === formDetail.form_list_id
    );

    setSelectedFormDetail(matchingForms[0]);
    set_selected_form(matchingForms[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    ["groupTitle", "mcode", "title"].forEach((field) => {
      if (!validator.fieldValid(field)) {
        validator.showMessageFor(field);
      }
    });

    setForceUpdate((prev) => !prev);

    if (validator.allValid()) {
      sweetConfirmAlert().then(async () => {
        setIsLoading(true);
        const child = {
          user_id: user_id,
          user_table_id: user_table_id,
          pid: pid,
          mcode: mcode,
          group_title: groupTitle,
          title: title,
          flg_node_hide: flg_node_hide,
          insert_type: insertType,
          display_order: displayOrder ? displayOrder : 0,
        };

        try {
          await insertHierarchyNode(child);
        } catch (error) {
          sweetStatusAlert("Failed!", "Unable to insert the node", "error");
        }
      });
    }
  };

  const handleUpdateSubmit = async (event) => {
    if (
      !validator.fieldValid("groupTitle") ||
      !validator.fieldValid("mcode") ||
      !validator.fieldValid("title")
    ) {
      validator.showMessages();
    } else {
      setIsLoading(true);
      const child = {
        mid: selected_card_id,
        mcode: mcode,
        group_title: groupTitle,
        title: title,
        flg_node_hide: flg_node_hide,
        display_order: displayOrder ? displayOrder : 0,
      };
      await TreeMainService.updateNodeDetails(child)
        .then((response) => {
          setIsLoading(false);
          setShowUpdateModal(false);
          sweetStatusAlert("Success!", "Node updated successfully", "success");
          getHierarchy(root_node_id, user_id, user_table_id);

          setMcode("");
          setGroupTitle("");
          set_flg_node_hide(0);
          setPid(null);
          setDisplayOrder(1);
          setDataId(null);
          setInsertType("null");
        })
        .catch((error) => {
          setIsLoading(false);
          sweetStatusAlert("Failed!", "Unable to insert the node", "error");
        });
    }
  };

  return (
    <>
      <AdminTemplate>
        <ContentWrapper>
          <Card>
            <CardHeader>
              <CardTitle
                cardLabel={highlightCard ? highlightCard.title : "..."}
              />
            </CardHeader>
            {isLoading ? (
              <PageSpinner id="show" text="Loading, Please wait!" />
            ) : (
              <CardBody>
                <Stack spacing={2}>
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    {breadcrumbs}
                  </Breadcrumbs>
                </Stack>

                <div className="">
                  <Grid container spacing={1} style={{ padding: "10px" }}>
                    {/* Left column with HirearchyCard components */}
                    {isHideForExam && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={2}
                        lg={2}
                        className={`card-section fade-in ${
                          isCardSectionVisible ? "" : "card-section-hidden"
                        }`}
                      >
                        {loadingNode ? (
                          <AddCard
                            toggleModal={toggleModal}
                            loading={loadingNode}
                          />
                        ) : (
                          <>
                            {hierarchyGridBottomData?.length > 0 &&
                              hierarchyGridBottomData.map((cardData, index) => {
                                const isSelected =
                                  cardData.mid === highlightCard?.mid;
                                return (
                                  <div
                                    key={index}
                                    ref={isSelected ? selectedCardRef : null}
                                  >
                                    <HirearchyCard
                                      singleNodeParentParent={
                                        hierarchyGridBottomData.length === 1
                                          ? hierarchyGridBottomData[
                                              hierarchyGridBottomData.length - 1
                                            ]
                                          : undefined
                                      }
                                      key={index}
                                      cardData={cardData}
                                      redirect={() => redirect(cardData)}
                                      redirectParent={redirect}
                                      getDashboardStats={getHierarchy}
                                      toggleUpdateModal={toggleUpdateModal}
                                      toggleInsertModal={toggleModal}
                                      user_id={user_id}
                                      highlightCard={highlightCard?.mid}
                                      user_table_id={user_table_id}
                                      setNodeLoading={set_loading_node_state}
                                      titles={titles}
                                    />
                                  </div>
                                );
                              })}

                            {breadcrumbsDataArray[breadcrumbsDataArray.length - 1] &&
                              breadcrumbsDataArray[
                                breadcrumbsDataArray.length - 1
                              ].flg_add_node_sibling && (
                                <AddCard toggleModal={toggleModal} />
                              )}
                          </>
                        )}
                      </Grid>
                    )}

                    {/* Right column with Tabs */}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={isHideForExam ? 10 : 12}
                      lg={isHideForExam ? 10 : 12}
                      className="fade-in"
                    >
                      <div className="tab-section">
                        {isHideForExam && (
                          <Box>
                            {formLoading ? (
                              <Tabs variant="scrollable" scrollButtons="auto">
                                <Tab key={0} label={"Loading..."} />
                              </Tabs>
                            ) : (
                              selectedMidsForms &&
                              highlightCard && (
                                <TabSection
                                  formArray={selectedMidsForms}
                                  pid={highlightCard.pid}
                                  title={highlightCard.title}
                                  setFormDetail={setFormDetail}
                                  selectedFormDetail={selected_form}
                                />
                              )
                            )}
                          </Box>
                        )}
                        {formLoading ? (
                          <div></div>
                        ) : (
                          <div
                            className=""
                            style={{ maxHeight: "90vh", overflowY: "auto" }}
                          >
                            {!!selectedMidsForms &&
                              selectedMidsForms.length > 0 &&
                              selectedFormDetail &&
                              handleApplicationSelect(selectedFormDetail)}
                          </div>
                        )}
                      </div>
                    </Grid>

                    <button
                      type="button"
                      className="menu-icon"
                      onClick={toggleCardSection}
                      style={{
                        display: !isMobile ? "none" : "inline-block",
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                      }}
                    >
                      <GridViewRoundedIcon />
                    </button>
                  </Grid>
                </div>
              </CardBody>
            )}
          </Card>
        </ContentWrapper>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={chat_backDrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {/* Card Section modal */}
        <Modal
          size="lg"
          centered
          onHide={() => setIsCardSectionVisible(false)}
          show={isCardSectionVisible}
        >
          <Modal.Header
            className="d-flex justify-content-end"
            closeButton
          ></Modal.Header>
          <Modal.Body>
            {loadingNode ? (
              <AddCard toggleModal={toggleModal} loading={loadingNode} />
            ) : (
              <>
                {hierarchyGridBottomData?.length > 0 &&
                  hierarchyGridBottomData.map((cardData, index) => {
                    const isSelected = cardData.mid === highlightCard?.mid;
                    return (
                      <div
                        key={index}
                        ref={isSelected ? selectedCardRef : null}
                      >
                        <HirearchyCard
                          singleNodeParentParent={
                            hierarchyGridBottomData.length === 1
                              ? hierarchyGridBottomData[
                                  hierarchyGridBottomData.length - 1
                                ]
                              : undefined
                          }
                          key={index}
                          cardData={cardData}
                          redirect={() => redirect(cardData)}
                          redirectParent={redirect}
                          getDashboardStats={getHierarchy}
                          toggleUpdateModal={toggleUpdateModal}
                          toggleInsertModal={toggleModal}
                          user_id={user_id}
                          highlightCard={highlightCard?.mid}
                          user_table_id={user_table_id}
                          setNodeLoading={set_loading_node_state}
                          titles={titles}
                        />
                      </div>
                    );
                  })}

                {breadcrumbsDataArray[breadcrumbsDataArray.length - 1] &&
                  breadcrumbsDataArray[breadcrumbsDataArray.length - 1]
                    .flg_add_node_sibling && (
                    <AddCard toggleModal={toggleModal} />
                  )}
              </>
            )}
          </Modal.Body>
        </Modal>
      </AdminTemplate>

      {/* Defining insert model */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showInsertModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {"L" === insertType
              ? `You are going to create an item`
              : `You are going to create an item`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="my-5">
              <Form.Group
                as={Col}
                md="6"
                controlId="exampleForm.ControlInput1"
                className="mb-3"
              >
                <Form.Label>ID</Form.Label>
                <Form.Control
                  type="text"
                  name="mcode"
                  placeholder="ID"
                  onChange={(e) => setMcode(e.target.value)}
                />
                {validator &&
                  validator.message("mcode", mcode, "required", {
                    className: "text-danger",
                    messages: { required: "Id is required." },
                  })}
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                <Form.Label>Main Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  placeholder="Main Title"
                  onChange={(e) => setTitle(e.target.value)}
                  className="mb-3"
                />
                {validator &&
                  validator.message("title", title, "required", {
                    className: "text-danger",
                    messages: { required: "Main title is required." },
                  })}
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                controlId="exampleForm.ControlInput1"
                className="my-3"
              >
                <Form.Label>Group Title</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  name="groupTitle"
                  value={groupTitle}
                  onChange={(e) => setGroupTitle(e.target.value)}
                  className="mb-3"
                >
                  <option value="">Select</option>
                  {titles.length > 0 ? (
                    titles.map((title) => (
                      <option key={title.group_id} value={title.group_id}>
                        {title.group_title}
                      </option>
                    ))
                  ) : (
                    <option value="">No titles available</option>
                  )}
                </Form.Select>
                {validator &&
                  validator.message(
                    "groupTitle",
                    groupTitle,
                    "required|max:20",
                    {
                      className: "text-danger",
                      messages: { required: "Group title is required." },
                    }
                  )}
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                controlId="exampleForm.ControlInput1"
                className="mt-3"
              >
                <Form.Label>Display Order</Form.Label>
                <Form.Control
                  type="number"
                  name="displayOrder"
                  step={1}
                  min={0}
                  max={100}
                  value={displayOrder}
                  placeholder="Display Order"
                  onChange={(e) => setDisplayOrder(e.target.value)}
                  className="mb-3"
                />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                <Row className="px-0 d-flex justify-content-between">
                  <Form.Label className="col-auto px-0">
                    Hide this item
                  </Form.Label>
                  <div className="col-auto px-0">
                    <Form.Check
                      type="checkbox"
                      name="flg_node_hide"
                      onChange={(e) =>
                        set_flg_node_hide(e.target.checked ? 1 : 0)
                      }
                      className="calendar-checkbox"
                    />
                  </div>
                </Row>
              </Form.Group>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={addBtnStyle} onClick={handleSubmit}>
            Add Item
          </Button>
          <Button id="modal-close-button" style={closeBtnStyle} onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Defining update model */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showUpdateModal}
        onHide={() => toggleUpdateModal()}
      >
        <Modal.Header closeButton>
          <Modal.Title>You are going to update the item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="my-5">
              <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                <Form.Label>ID</Form.Label>
                <Form.Control
                  type="text"
                  name="mcode"
                  placeholder="ID"
                  value={mcode}
                  onChange={(e) => setMcode(e.target.value)}
                />
                {validator &&
                  validator.message("mcode", mcode, "required", {
                    className: "text-danger",
                    messages: { required: "Id is required." },
                  })}
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                <Form.Label>Main Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  placeholder="Main Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {validator &&
                  validator.message("title", title, "required", {
                    className: "text-danger",
                    messages: { required: "Main title is required." },
                  })}
              </Form.Group>
            </Row>
            <Row className="my-5">
              <Form.Group
                as={Col}
                md="6"
                controlId="exampleForm.ControlInput1"
                className="my-3"
              >
                <Form.Label>Group Title</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  name="groupTitle"
                  value={groupTitle}
                  onChange={(e) => setGroupTitle(e.target.value)}
                >
                  <option value="">Select</option>
                  {titles.length > 0 ? (
                    titles.map((title) => (
                      <option key={title.group_id} value={title.group_id}>
                        {title.group_title}
                      </option>
                    ))
                  ) : (
                    <option value="">No titles available</option>
                  )}
                </Form.Select>
                {validator &&
                  validator.message(
                    "groupTitle",
                    groupTitle,
                    "required|max:20",
                    {
                      className: "text-danger",
                      messages: { required: "Group title is required." },
                    }
                  )}
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                controlId="exampleForm.ControlInput1"
                className="mt-3"
              >
                <Form.Label>Display Order</Form.Label>
                <Form.Control
                  type="number"
                  name="displayOrder"
                  step={1}
                  min={0}
                  max={100}
                  placeholder="Display Order"
                  value={displayOrder}
                  onChange={(e) => setDisplayOrder(e.target.value)}
                  className="mb-3"
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Row className="px-0 d-flex justify-content-between">
                  <Form.Label className="col-auto px-0">
                    Hide this item
                  </Form.Label>
                  <div className="col-auto px-0">
                    <Form.Check
                      type="checkbox"
                      name="flg_node_hide"
                      onChange={(e) =>
                        set_flg_node_hide(e.target.checked ? 1 : 0)
                      }
                      checked={flg_node_hide === 1}
                    />
                  </div>
                </Row>
              </Form.Group>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            style={addBtnStyle}
            onClick={(event) => handleUpdateSubmit(event)}
          >
            Update
          </Button>
          <Button id="modal-close-button" style={closeBtnStyle} onClick={() => toggleUpdateModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EdfociNodeBuilder;
